var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: [
        "customer-invoices-general-data-container",
        _vm.breakpointClass,
        "pa-0",
        _vm.contextClass,
      ],
    },
    [
      _vm.loadingData
        ? _c("SpinnerLayerComponent", { staticClass: "spinner-layer" })
        : [
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  {
                    staticClass: "customer-invoices-form",
                    attrs: {
                      cols: "12",
                      lg:
                        _vm.initialRenderMode &&
                        !_vm.isProviderBankdraftTab &&
                        !_vm.formFullWidth
                          ? 8
                          : 12,
                      xl:
                        _vm.initialRenderMode &&
                        !_vm.isProviderBankdraftTab &&
                        !_vm.formFullWidth
                          ? 9
                          : 12,
                    },
                  },
                  [
                    !_vm.initialRenderMode
                      ? _c("TabHeaderComponent", {
                          staticClass: "tab-header",
                          attrs: { buttons: _vm.buttons, title: _vm.formTitle },
                          on: {
                            closeForm: _vm.closeDetailForm,
                            saveForm: _vm.onSaveForm,
                            removeItem: _vm.onTabHeaderComponentRemove,
                          },
                        })
                      : _vm._e(),
                    _vm.formSchema && _vm.fieldValues
                      ? _c("FormGeneratorComponent", {
                          attrs: {
                            schema: _vm.formSchema,
                            fieldValues: _vm.fieldValues,
                            context: _vm.invoiceInfo.context,
                            validateOnLoad: "",
                            permissionsEntity: _vm.permissionsEntity,
                          },
                          on: {
                            lexonButtonEvent: _vm.lexonButtonEvent,
                            saveFormData: _vm.onChangeFormFieldValue,
                            isValidForm: _vm.onIsValidForm,
                            "emit-on-blur-event": function ($event) {
                              return _vm.fillTextfieldFields(
                                _vm.fieldValues,
                                _vm.selectedInvoiceCompanyInfoCloned
                              )
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm.initialRenderMode && _vm.showTotalsWidgetAndGrid
                  ? _c(
                      "v-col",
                      {
                        staticClass:
                          "isProviderBankdraftTab ? provider-invoice-totals : billing-totals",
                        attrs: {
                          cols: "12",
                          lg: _vm.isProviderBankdraftTab ? 12 : 4,
                          xl: _vm.isProviderBankdraftTab ? 12 : 3,
                        },
                      },
                      [
                        _vm.isProviderBankdraftTab
                          ? _c("LfTotalsComponent", {
                              attrs: { items: _vm.totals },
                            })
                          : _c("BillingTotalsContainerComponent", {
                              attrs: { items: _vm.totals },
                            }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm.initialRenderMode && _vm.showTotalsWidgetAndGrid
              ? _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { staticClass: "grid-container", attrs: { cols: "12" } },
                      [
                        _c("LfGridComponent", {
                          attrs: {
                            gridConfiguration: _vm.gridConfiguration,
                            itemData: _vm.listItems,
                            toolbarOptions: _vm.toolbarOptionsCustom,
                            contextMenuItems: _vm.contextMenuItems,
                            commandClick: _vm.onCommandClick,
                            exportName: _vm.texts.gridTitle,
                          },
                          on: {
                            toolbarClicked: _vm.onToolbarClicked,
                            rowClick: _vm.onRowClicked,
                            contextMenuClicked: _vm.onContextMenuClicked,
                          },
                        }),
                        _c("PromptDialogComponent", {
                          attrs: {
                            title: _vm.formTitle,
                            isOpened: _vm.openedPrompt,
                            context: _vm.invoiceInfo.detailForm,
                            formSchema: _vm.formDetailSchema,
                            formFieldValues: _vm.formData,
                            width: 950,
                          },
                          on: {
                            "execute-action": _vm.onExecuteAction,
                            changeFormField: _vm.onChangeFormFieldValue,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }